import { Theme } from "@mui/material/styles";
import { primaryColor } from "../../theme";

const styles = (theme: Theme) =>
  ({
    dropdown: {
      background: primaryColor,
      color: 'white',
      padding: '0 6px 0 5px',
      borderRadius: 0,
      top: '37px !important',
      width: 53,
      '& .MuiMenuItem-root': {
      fontFamily: '"Barlow", sans-serif',
        fontSize: 15,
        padding: 0,
        paddingLeft: 5,
      },
    },
  } as any);

export default styles;
